// extracted by mini-css-extract-plugin
module.exports = {"root":"TooltipConfig_root__2Xrf5","tooltipArea":"TooltipConfig_tooltipArea__3KKcr","tooltipEdit":"TooltipConfig_tooltipEdit__i_80M"};